import React from 'react'
import styles from './_notfound.css'
import { FormattedMessage } from 'react-intl'

export default function NotFoundPage () {
  return (
    <div className={styles.container}>
      <div className={styles.inner}>
        <h1 className={styles.giant}>
          <FormattedMessage
            id='notfoundpage.error_code'
            defaultMessage='404'
          />
        </h1>
        <h1 className={styles.title}>
          <FormattedMessage
            id='notfoundpage.title'
            defaultMessage='Not found'
          />
        </h1>
      </div>
    </div>
  )
}
